// extracted by mini-css-extract-plugin
export default {"show-more-btn":"showMore_show-more-btn__bZjMB","children-desktop":"showMore_children-desktop__53nHE"};